/*
 * @Author: 刘小博
 * @Date: 2023-02-17 10:33:23
 * @LastEditTime: 2023-02-17 11:25:45
 * @LastEditors: 刘小博
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\mg\service-project-manage\index.js
 * 服务商项目管理
 */
import serviceProjectRouter from './modules/serviceProjectRouter'
const serviceProjectManageRouter = [].concat(serviceProjectRouter)
export default serviceProjectManageRouter
